<template>
    <div id="broadcastList" :class="checkMobileStatus ? 'mobile-view' : ''">
        <div class="content-body-container">

            <div>
                <div class="row" style="margin: 0px;">
                    <div class="broadcast-list-container" style="background: white; text-align: left; min-height: 728px; width: 70%; padding: 20px;">
                        <div class="default-title-container" style="margin-bottom: 15px;">
                            <span class="sans-font-style-size-35" style="color: #53617A;">{{lang("Broadcast List")}}</span>
                        </div>

                        <div class="broadcast-list-content-container">

                            <div class="each-broadcast-container" v-if="arrobj_BroadcastPost.length > 0">
                                <div class="each-broadcast"
                                     style="background: #EDF0F4; border-radius: 6px;"
                                     v-for="(each_broadcast, index) in arrobj_BroadcastPost"
                                     :key="index"
                                     @click="selectedEachBroadcast(each_broadcast)">

                                    <div class="each-broadcast-profile-container">
                                        <div class="profile">
                                            <img src="../assets/boy.png" v-if="each_broadcast.ProfileImage === ''">
                                            <img :src="each_broadcast.ProfileImage" v-if="each_broadcast.ProfileImage"/>
                                        </div>

                                        <div class="feed-heading sans-font-style-size-12" style="vertical-align: middle">
                                            <span class="sans-font-style-size-12">{{each_broadcast.CONname}}</span>
                                            <small class="date sans-font-style-size-12">
                                                {{each_broadcast.PostCreatedDate_convert}}
                                            </small>
                                        </div>
                                    </div>

                                    <div class="each-broadcast-image-container" style="margin: 15px 0px;">
<!--                                        @click="showBroadcastReadMore(each_broadcast)"-->
                                        <div class="col-12" style="padding: 0px;">
                                            <div class="image-wrapper">
                                                <ul>
                                                    <li style="height: 160px; border-radius: 6px; background: #ffffff; padding: 0px;"
                                                        class="postFile__item"
                                                        v-for="(obj_Images, index) in each_broadcast.eachBroadcastDetails"
                                                        :key="obj_Images.PostItemID"
                                                        v-if="index < 1 && each_broadcast.hasCover">
                                                        <img class="single-broadcast-image" style="object-fit: scale-down;"
                                                             v-if="isImageByExt(obj_Images)"
                                                             :src="obj_Images.FilePath" />

                                                        <LazyVideo class="nonM card-img-top d-block img-fluid w-100" v-else-if="isVideo(obj_Images)"
                                                                   style="object-fit: contain;"
                                                                   :src="obj_Images.FilePath"
                                                                   controlsList="nodownload" />

                                                        <audio class="nonM card-img-top d-block img-fluid w-100" v-else-if="isAudio(obj_Images)"
                                                               controls style="object-fit: contain;">
                                                            <source :src="obj_Images.FilePath"
                                                                    :type="obj_Images.PostItemFileType">
                                                        </audio>

                                                        <div v-else style="width: 100%; height: 100%; overflow: auto;">
                                                            <pdf class="nonM card-img-top d-block img-fluid"
                                                                 v-if="!isImageByExt(obj_Images) && !isVideo(obj_Images) && !isAudio(obj_Images)
                                                                 && obj_Images.PostItemFileExt.toLowerCase() === '.pdf'"
                                                                 v-for="i in obj_Images.numPages" :key="i" :page="i" style="display: block; width: 100%;"
                                                                 :src="obj_Images.pageOfSrc" >
                                                            </pdf>
                                                        </div>
                                                    </li>

                                                    <li style="height: 160px; border-radius: 6px; background: #ffffff;" class="postFile__item"
                                                        v-if="!each_broadcast.hasCover">
                                                        <img class="single-broadcast-image" style="object-fit: scale-down;"
                                                             :src="defaultBgImage" />
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="each-broadcast-msg-container">

                                        <div class="form-group">
                                            <div class="box broadcast-msg" style="padding: 0px; text-align: left; border-radius: 5px;">
                                                <p>
                                                    <!--<span style="white-space: pre-line;">{{each_broadcast.PostContent}}</span>-->
                                                    <span style="white-space: pre-line;" v-html="each_broadcast.PostContent"></span>

                                                    <br/>
                                                    <span style="white-space: pre-line;" v-html="each_broadcast.PostBroadDtlMsg"></span>
                                                </p>
<!--                                                <label style="cursor: pointer;"-->
<!--                                                       @click="selectedEachBroadcast(each_broadcast)">{{lang("Read More")}}</label>-->
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="empty-list_image" v-if="arrobj_BroadcastPost.length <= 0">
                                <div v-if="!isLoading">
                                    <strong class="sans-font-style-size-25">{{empty_message}}</strong>
                                    <img src="../assets/notfound.png"/>
                                </div>
                            </div>

                            <div class="lds-ellipsis" v-if="isLoading">
                                <div></div>
                                <div></div>
                                <div></div>
                                <div></div>
                            </div>

                        </div>
                    </div>

                    <div class="broadcast-details-container">
                        <div class="default-title-container" style="margin-bottom: 15px;">
                            <span class="sans-font-style-size-25" style="color: #222222;">{{lang("Broadcast Details")}}</span>
                        </div>

                        <div class="broadcast-details-content-container" style="text-align: left;">
                            <div class="single-broadcast-details-container" v-if="!isNull(arrobj_singleBroadcast)">
                                <div class="single-broadcast-details" @click="showBroadcastReadMore(arrobj_singleBroadcast)"
                                     style="background: #EDF0F4; border-radius: 6px; cursor: pointer;">

                                    <div class="each-broadcast-profile-container">
                                        <div class="profile">
                                            <img src="../assets/boy.png" v-if="arrobj_singleBroadcast.ProfileImage === ''">
                                            <img :src="arrobj_singleBroadcast.ProfileImage" v-if="arrobj_singleBroadcast.ProfileImage"/>
                                        </div>

                                        <div class="feed-heading sans-font-style-size-12" style="vertical-align: middle">
                                            <span class="sans-font-style-size-12">{{arrobj_singleBroadcast.CONname}}</span>
                                            <small class="date sans-font-style-size-12">
                                                {{arrobj_singleBroadcast.PostCreatedDate_convert}}
                                            </small>
                                        </div>
                                    </div>

                                    <div class="each-broadcast-image-container" style="margin: 15px 0px;">
                                        <div class="col-12" style="padding: 0px; cursor: pointer;"
                                             @click="showBroadcastReadMore(arrobj_singleBroadcast)">
                                            <div class="image-wrapper">
                                                <ul>
                                                    <li style="height: 160px; border-radius: 6px; background: #ffffff; padding: 0px;" class="postFile__item"
                                                        v-for="(obj_Images, index) in arrobj_singleBroadcast.eachBroadcastDetails"
                                                        :key="obj_Images.PostItemID"
                                                        v-if="index < 1 && arrobj_singleBroadcast.hasCover">
                                                        <img class="single-broadcast-image" style="object-fit: scale-down;"
                                                             v-if="isImageByExt(obj_Images)"
                                                             :src="obj_Images.FilePath" />

                                                        <LazyVideo class="nonM card-img-top d-block img-fluid w-100" v-else-if="isVideo(obj_Images)"
                                                                   style="object-fit: contain;"
                                                                   :src="obj_Images.FilePath"
                                                                   controlsList="nodownload" />

                                                        <audio class="nonM card-img-top d-block img-fluid w-100" v-else-if="isAudio(obj_Images)"
                                                               controls style="object-fit: contain;">
                                                            <source :src="obj_Images.FilePath"
                                                                    :type="obj_Images.PostItemFileType">
                                                        </audio>

                                                        <div v-else style="width: 100%; height: 100%; overflow: auto;">
                                                            <pdf class="nonM card-img-top d-block img-fluid"
                                                                 v-if="!isImageByExt(obj_Images) && !isVideo(obj_Images) && !isAudio(obj_Images)
                                                                 && obj_Images.PostItemFileExt.toLowerCase() === '.pdf'"
                                                                 v-for="i in obj_Images.numPages" :key="i" :page="i" style="display: block; width: 100%;"
                                                                 :src="obj_Images.pageOfSrc" >
                                                            </pdf>
                                                        </div>

                                                        <button v-if="Object.keys(arrobj_singleBroadcast.eachBroadcastDetails).length > 1"
                                                                class="postFile-remainingNumber">
                                                            <span>+ {{(Object.keys(arrobj_singleBroadcast.eachBroadcastDetails).length - 1)}}</span>
                                                        </button>
                                                    </li>

                                                    <li style="height: 160px; border-radius: 6px; background: #ffffff;" class="postFile__item"
                                                        v-if="!arrobj_singleBroadcast.hasCover">
                                                        <img class="single-broadcast-image" style="object-fit: scale-down;"
                                                             :src="defaultBgImage" />
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="each-broadcast-msg-container"
                                         style="max-height: calc(100vh - 310px); overflow-y: auto; overflow-x: hidden;">
                                        <div class="form-group">
                                            <div class="formDiv" style="padding: 0px; text-align: left; border-radius: 5px;">
                                                <p class="sans-font-style" style="font-size: 14px; margin: 0px;">
                                                    <!--<span style="white-space: pre-line;">{{arrobj_singleBroadcast.PostContent}}</span>-->
                                                <span class="post-content" v-html="arrobj_singleBroadcast.PostContent"></span>
                                                </p>
                                            </div>
                                        </div>

                                        <div class="form-group" v-if="arrobj_singleBroadcast.PostBroadDtlMsg">
                                            <div class="box single-broadcast-msg"
                                                 style="padding: 0px; text-align: left; border-radius: 5px;">
<!--                                                <input type="checkbox" :id="'expanded-'+index" @change="changeMsg('expanded-'+index)">-->
                                                <p v-html="arrobj_singleBroadcast.PostBroadDtlMsg"
                                                   style="white-space: pre-line; word-break: break-word;"></p>
<!--                                                <label :for="'expanded-'+index" role="button" style="outline: unset;"-->
<!--                                                       v-if="arrobj_singleBroadcast.totalLine >= 2">Read More</label>-->
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


            <div class="broadcast-list-header-container" style="margin-bottom: 20px; display: none;">

                <div class="row" style="margin: 0px;" v-if="!checkMobileStatus">
                    <div class="default-title-container">
                        <i class="fa fa-bullhorn" style="color: #536170; margin-right: 10px; font-size: 20px;"></i>
                        <span class="sans-font-style-size-22" style="color: #536170;">{{lang("Broadcast")}}</span>
                    </div>

<!--                    <div class="broadcast-action-button" v-if="isParent === 'Principal'" style="margin-left: auto;">-->
<!--                        <button class="btn sans-font-style btn-create-new-broadcast" @click="showBroadcast">-->
<!--                            <i class="fa fa-plus btn-plus-icon" aria-hidden="true"></i>{{lang("Broadcast")}}</button>-->
<!--                    </div>-->
                </div>
            </div>

            <div class="broadcast-list-content-container" style="text-align: left; display: none;">

                <div class="empty-list_image" v-if="arrobj_BroadcastPost.length <= 0">
                    <div v-if="!isLoading">
                        <strong>{{empty_message}}</strong>
                        <img src="../assets/notfound.png"/>
                    </div>
                </div>

                <div class="each-broadcast-container" v-if="arrobj_BroadcastPost.length > 0">
                    <div class="each-broadcast"
                         v-for="(each_broadcast, index) in arrobj_BroadcastPost" :key="index">
<!--                        @click="showBroadcastReadMore(each_broadcast)"-->

                        <div class="col-12" style="padding: 0px;" @click="showBroadcastReadMore(each_broadcast)">
<!--                            style="background: #E1E6F0;"-->
                            <div class="image-wrapper">
                                <ul>
                                    <li style="height: 300px;" class="postFile__item"
                                        v-for="(obj_Images, index) in each_broadcast.eachBroadcastDetails"
                                        :key="obj_Images.PostItemID"
                                        v-if="index < 1 && each_broadcast.hasCover">
<!--                                        :src="`data:`+obj_Images.PostItemFileType+`;base64, ${obj_Images.PostItemFile}`"-->
                                        <img class="single-broadcast-image" style="object-fit: unset;"
                                             v-if="isImageByExt(obj_Images)"
                                             :src="obj_Images.FilePath" />

                                        <LazyVideo class="nonM card-img-top d-block img-fluid w-100" v-else-if="isVideo(obj_Images)"
                                                   style="object-fit: contain;"
                                                   :src="obj_Images.FilePath"
                                                   controlsList="nodownload" />

                                        <audio class="nonM card-img-top d-block img-fluid w-100" v-else-if="isAudio(obj_Images)"
                                               controls style="object-fit: contain;">
                                            <source :src="obj_Images.FilePath"
                                                    :type="obj_Images.PostItemFileType">
                                        </audio>

                                        <div v-else style="width: 100%; height: 100%; overflow: auto;">
                                            <pdf class="nonM card-img-top d-block img-fluid"
                                                 v-if="!isImageByExt(obj_Images) && !isVideo(obj_Images) && !isAudio(obj_Images)
                                                 && obj_Images.PostItemFileExt.toLowerCase() === '.pdf'"
                                                 v-for="i in obj_Images.numPages" :key="i" :page="i" style="display: block; width: 100%;"
                                                 :src="obj_Images.pageOfSrc" >
                                            </pdf>
                                        </div>
                                    </li>

                                    <li style="height: 300px;" class="postFile__item"
                                        v-if="!each_broadcast.hasCover">
                                        <img class="single-broadcast-image" style="object-fit: unset;"
                                             :src="defaultBgImage" />
                                    </li>
                                </ul>
                            </div>
                        </div>

                        <div class="col-12" style="text-align: left; padding: 10px;">
                            <div class="profile">
                                <img src="../assets/boy.png" v-if="each_broadcast.ProfileImage === ''">
<!--                                <img :src="`data:image/jpg;base64, ${each_broadcast.ProfileImage}`" v-if="each_broadcast.ProfileImage"/>-->
                                <img :src="each_broadcast.ProfileImage" v-if="each_broadcast.ProfileImage"/>
                            </div>

                            <div class="feed-heading sans-font-style-size-12" style="vertical-align: middle">
                                <span class="sans-font-style-size-12">{{each_broadcast.CONname}}</span>
                                <small class="date sans-font-style-size-12">
                                    {{each_broadcast.PostCreatedDate_convert}}
                                </small>
                            </div>

                            <div class="form-group" style="margin-top: 10px;">
                                <div class="col-md-12 formDiv" style="padding: 10px 10px; text-align: left; border-radius: 5px;">
                                    <p class="sans-font-style" style="font-size: 14px; margin: 0px;">
                                        <span style="white-space: pre-line;">{{each_broadcast.PostContent}}</span>
                                    </p>
                                </div>
                            </div>

<!--                            <div class="form-group" style="margin-top: 10px;">-->
<!--                                <div class="col-md-12 formDiv" style="padding: 10px 10px; text-align: left; border-radius: 5px;">-->
<!--                                    <p class="sans-font-style broadcast-msg" style="font-size: 14px; margin: 0px;">-->
<!--                                        <input type="checkbox" id="expanded">-->
<!--                                        <span>{{each_broadcast.PostBroadDtlMessage}}</span>-->
<!--                                        <label for="expanded" role="button">read more</label>-->
<!--                                    </p>-->
<!--                                </div>-->
<!--                            </div>-->

                            <div class="form-group" style="margin-top: 10px;" v-if="each_broadcast.PostBroadDtlMsg">
                                <div class="col-md-12 box broadcast-msg"
                                     style="padding: 10px 10px; text-align: left; border-radius: 5px;">
                                    <input type="checkbox" :id="'expanded-'+index" @change="changeMsg('expanded-'+index)">
<!--                                    <p>{{each_broadcast.PostBroadDtlMsg}}</p>-->
                                    <p v-html="each_broadcast.PostBroadDtlMsg"></p>
                                    <label :for="'expanded-'+index" role="button" style="outline: unset;"
                                           v-if="each_broadcast.totalLine >= 2">Read More</label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="lds-ellipsis" v-if="isLoading">
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                </div>

                <!--                show create broadcast modal  :title="modalTitle ? modalTitle : 'Post'"-->
                <b-modal id="modal1" size="lg" hide-footer :title="lang('Broadcast')" v-model="isModalOpen"
                         @hidden="hideComponentModal">
                    <!--                    <el-button-group class="mb-4 modal-quicklink">-->
                    <!--                        <el-button type="primary" @click="showBroadcast" :class="{'active':modalTitle === 'Broadcast'}"><i-->
                    <!--                                class="fa fa-bullhorn" aria-hidden="true"></i> <span>{{lang("Broadcast")}}</span></el-button>-->
                    <!--&lt;!&ndash;                        <el-button type="primary" @click="showUpdates" :class="{'active':modalTitle === 'Post'}"><i&ndash;&gt;-->
                    <!--&lt;!&ndash;                                class="fa fa-newspaper-o" aria-hidden="true"></i> <span> Updates</span></el-button>&ndash;&gt;-->
                    <!--&lt;!&ndash;                        <el-button type="primary" @click="showPortfolio" :class="{'active':modalTitle === 'Portfolio'}"><i&ndash;&gt;-->
                    <!--&lt;!&ndash;                                class="fa fa-book" aria-hidden="true"></i> <span> Portfolio</span></el-button>&ndash;&gt;-->
                    <!--                    </el-button-group>-->
                    <component
                            @result="displayResult"
                            :is="obj_SelectedComponent"
                            @loadPosts="loadPosts"
                            @loadBroadcast="loadBroadcast"
                    ></component>

                </b-modal>

                <b-modal id="modal2" hide-footer :title="modalTitle ? modalTitle : 'Post'" size="lg" @hidden="hideComponentModal" v-model="isCreateModalOpen">
                    <template v-slot:modal-header="">
                        <h4>{{lang("CREATE")}}{{lang("BROADCAST")}}</h4>
                        <button class="btn btn-default btn-import-image">{{lang("Import")}}{{lang("Image")}}</button>

                        <input type="file" multiple class="" id="uploadImage" hidden="hidden"/>
                    </template>

                    <component :is="selectedComponent"></component>
                </b-modal>

                <!--                show each broadcast more details-->
                <b-modal id="modal_broadcastReadMore" ref="modal_broadcastReadMore" centered hide-footer hide-header>
                    <div>
                        <h5>{{lang("Broadcast")}}{{lang("Details")}}</h5>
                    </div>

                    <div v-loading="loading">
                        <singleFeedComponent
                                :parent-post="tempBroadcastModalPostID"
                                @loadPosts="loadPosts"
                                ref="pComponent"
                                :hideComment="true"
                                @loadingclose="loadingclose"
                        />
                    </div>
                </b-modal>
            </div>

            <!--                show create broadcast modal  :title="modalTitle ? modalTitle : 'Post'"-->
            <b-modal id="modal1" size="lg" hide-footer :title="lang('Broadcast')" v-model="isModalOpen"
                     @hidden="hideComponentModal">
                <!--                    <el-button-group class="mb-4 modal-quicklink">-->
                <!--                        <el-button type="primary" @click="showBroadcast" :class="{'active':modalTitle === 'Broadcast'}"><i-->
                <!--                                class="fa fa-bullhorn" aria-hidden="true"></i> <span>{{lang("Broadcast")}}</span></el-button>-->
                <!--&lt;!&ndash;                        <el-button type="primary" @click="showUpdates" :class="{'active':modalTitle === 'Post'}"><i&ndash;&gt;-->
                <!--&lt;!&ndash;                                class="fa fa-newspaper-o" aria-hidden="true"></i> <span> Updates</span></el-button>&ndash;&gt;-->
                <!--&lt;!&ndash;                        <el-button type="primary" @click="showPortfolio" :class="{'active':modalTitle === 'Portfolio'}"><i&ndash;&gt;-->
                <!--&lt;!&ndash;                                class="fa fa-book" aria-hidden="true"></i> <span> Portfolio</span></el-button>&ndash;&gt;-->
                <!--                    </el-button-group>-->
                <component
                        @result="displayResult"
                        :is="obj_SelectedComponent"
                        @loadPosts="loadPosts"
                        @loadBroadcast="loadBroadcast"
                ></component>

            </b-modal>

            <b-modal id="modal2" hide-footer :title="modalTitle ? modalTitle : 'Post'" size="lg" @hidden="hideComponentModal" v-model="isCreateModalOpen">
                <template v-slot:modal-header="">
                    <h4>{{lang("CREATE")}}{{lang("BROADCAST")}}</h4>
                    <button class="btn btn-default btn-import-image">{{lang("Import")}}{{lang("Image")}}</button>

                    <input type="file" multiple class="" id="uploadImage" hidden="hidden"/>
                </template>

                <component :is="selectedComponent"></component>
            </b-modal>

            <!--                show each broadcast more details-->
            <b-modal id="modal_broadcastReadMore" ref="modal_broadcastReadMore" centered hide-footer hide-header>
                <div>
                    <h5>{{lang("Broadcast")}}{{lang("Details")}}</h5>
                </div>

                <div v-loading="loading">
                    <singleFeedComponent
                            :parent-post="tempBroadcastModalPostID"
                            @loadPosts="loadPosts"
                            ref="pComponent"
                            :hideComment="true"
                            @loadingclose="loadingclose"
                    />
                </div>
            </b-modal>
        </div>
    </div>
</template>

<script>
    "use strict";
    import DataSource from "../data/datasource";
    import $ from 'jquery';
    import Cookies from "js-cookie";

    import singleFeedComponent from "../components/singleFeedComponent";
    import portfolio from "../components/Post_Portfolio_Component";
    import updates from "../components/Post_Updates_Component.vue";
    import broadcast from "../components/Post_Broadcast_Component.vue";
    import {lang} from '../locale/index';

    import defaultBgImage from "../assets/kagami-horn.png";

    import { NotifEvent, notifGlobalVariable } from '../global/index.js';

    import pdf from 'vue-pdf';

    import Vue from 'vue';
    import VueLazyLoadVideo from 'vue-lazyload-video';
    Vue.use(VueLazyLoadVideo);

    export default {
        name: "StaffBroadcast",
        components: {
            singleFeedComponent,
            pdf,
            // eventCom,
        },
        data() {
            return {
                modalTitle: null,
                lastPostID: null,

                filter_array: ["Filter", "All", "Unread"],
                arrobj_BroadcastPost: [],
                tempBroadcastModalPostID: [],
                list: [],
                array_postID: [],
                arrobj_notif: [{
                    NotiValue: "",
                    NotiType: "",
                }],
                singlePostID: [],
                arrobj_singleBroadcast: [],

                selected: "Filter",
                isParent: "",
                defaultBgImage: defaultBgImage,
                selectedComponent: "",
                // empty_message: lang("Please contact Kagami administrator"),
                empty_message: lang("Broadcast")+lang("Not Found"),

                int_NumberOfPost: 10,

                bool_ShowRefresh: false,
                feedLoader: false,
                isModalOpen: false,
                isLoading: true,
                loading: true,
                obj_SelectedComponent: false,
                isCreateModalOpen: false,
                hasParams: false,
                isChange: false,

                checkMobileStatus: false,
                isMsgReadMore: true,

                notShow: 'Portfolio',
                isShow: 'Broadcast',
            };
        },
        created() {
            window.addEventListener('resize', this.isMobile);
        },
        destroyed () {
            $(window).unbind('scroll');
            // NotifEvent.$off("notificationType");
            this.$root.$off("notificationType");
            window.removeEventListener('resize', this.isMobile);
        },
        methods: {
            lang,
            loadingclose() {
                this.loading = false;
            },
            loadBroadcast() {
                this.sleep(200);
                this.$vs.loading();
                this.isLoading = true;
                this.isParent = Cookies.get('userTypeSession');
                this.arrobj_BroadcastPost = [];

                let promise_GetPosts = this.isParent === "Parent" ?
                    DataSource.shared.getParentPost(10, null, "BROADCAST")
                    : DataSource.shared.getStaffPost(10, null, "BROADCAST");

                promise_GetPosts.then((response) => {
                    if (response.Table){
                        response.Table.forEach((object, index) => {
                            object.hasCover = false;

                            // if (object.PostBroadDtlMsg) {
                            //     object.PostBroadDtlMsg = this.replaceWithLink(object.PostBroadDtlMsg);
                            // }

                            if (index === (response.Table.length -1)) {
                                this.lastPostID = object.PostID;
                            }

                            let promise_GetCoverImage = DataSource.shared.getPostFileReturnFilePath(object.PostID);

                            promise_GetCoverImage.then((postResponse) => {
                                if (postResponse.Table) {
                                    object.hasCover = true;

                                    postResponse.Table.forEach(file => {
                                        file.numPages = undefined;

                                        if (file.PostItemFileExt.toLowerCase() === ".pdf") {
                                            let src = pdf.createLoadingTask(file.FilePath);
                                            file.pageOfSrc = src;
                                            src.promise.then(pdf => {
                                                file.numPages = pdf.numPages;
                                            });
                                        }
                                        file.oriFilePath = file.FilePath;

                                        var filename = file.PostItemID + file.PostItemFileExt;
                                        this.urltoFile(file.FilePath, filename, file.PostItemFileType).then((blobFile) => {
                                            var url = window.URL.createObjectURL(blobFile);

                                            file.FilePath = url;
                                        }).finally(() => {
                                            // this.getImagePreviews();
                                        });
                                    });

                                    // object.eachBroadcastDetails = postResponse.Table;
                                    this.$set(object, "eachBroadcastDetails", postResponse.Table);
                                }
                            });
                        });

                        return response;
                    }
                }).then((result) => {
                    if (result !== undefined && result.Table) {
                        this.arrobj_BroadcastPost.push.apply(this.arrobj_BroadcastPost, result.Table);
                        this.arrobj_singleBroadcast = this.arrobj_BroadcastPost[0];
                        this.changeMsg("");
                    }

                    this.isLoading = false;
                    this.$vs.loading.close();
                });
            },
            loadPosts() {

                // hide the modal and load broadcast again
                this.loadBroadcast();
                this.$refs.modal_broadcastReadMore.hide();
                // this.showSession()
                // user menu
                this.feedLoader = !this.feedLoader;

                $("html, body").animate({scrollTop: 0}, "fast");
                this.bool_ShowRefresh = false;
                this.isParent = Cookies.get('userTypeSession');
                this.list = [];
                let promise_GetPosts = this.isParent === "Parent" ?
                    DataSource.shared.getParentPostFeedPage(this.int_NumberOfPost, '', '', this.notShow)
                    : DataSource.shared.getStaffPostFeedPage(this.int_NumberOfPost, '', '', this.notShow, '', this.isShow, '');

                promise_GetPosts.then((response) => {
                    if (response.Table)
                        this.list.push.apply(this.list, response.Table);

                    this.isLoading = false;
                    this.feedLoader = !this.feedLoader;

                });
            },
            // load more broadcast result
            loadMoreBroadcast() {
                this.isParent = Cookies.get('userTypeSession');
                this.isLoading = true;

                let promise_GetPosts = this.isParent === "Parent" ?
                    DataSource.shared.getParentPost(10, this.lastPostID, "BROADCAST")
                    : DataSource.shared.getStaffPost(10, this.lastPostID, "BROADCAST");

                promise_GetPosts.then((response) => {
                    if (response.Table){
                        // this.arrobj_BroadcastPost.push.apply(this.arrobj_BroadcastPost, response.Table);

                        response.Table.forEach((object, index) => {
                            // if (object.PostBroadDtlMsg) {
                            //     object.PostBroadDtlMsg = this.replaceWithLink(object.PostBroadDtlMsg);
                            // }

                            if (index === (response.Table.length -1)) {
                                this.lastPostID = object.PostID;
                            }
                            let promise_GetCoverImage = DataSource.shared.getPostFileReturnFilePath(object.PostID);

                            promise_GetCoverImage.then((postResponse) => {
                                // if (postResponse.Table)
                                //     object.eachBroadcastDetails = postResponse.Table;
                                if (postResponse.Table) {
                                    object.hasCover = true;

                                    postResponse.Table.forEach(file => {
                                        file.numPages = undefined;

                                        if (file.PostItemFileExt.toLowerCase() === ".pdf") {
                                            let src = pdf.createLoadingTask(file.FilePath);
                                            file.pageOfSrc = src;
                                            src.promise.then(pdf => {
                                                file.numPages = pdf.numPages;
                                            });
                                        }
                                        file.oriFilePath = file.FilePath;

                                        var filename = file.PostItemID + file.PostItemFileExt;
                                        this.urltoFile(file.FilePath, filename, file.PostItemFileType).then((blobFile) => {
                                            var url = window.URL.createObjectURL(blobFile);

                                            file.FilePath = url;
                                        }).finally(() => {
                                            // this.getImagePreviews();
                                        });
                                    });

                                    // object.eachBroadcastDetails = postResponse.Table;
                                    this.$set(object, "eachBroadcastDetails", postResponse.Table);
                                }
                            });
                        });

                        this.arrobj_BroadcastPost.push.apply(this.arrobj_BroadcastPost, response.Table);
                    }

                    this.isLoading = false;
                });
            },

            showBroadcastReadMore(Post) {
                this.tempBroadcastModalPostID = Post;
                this.$refs.modal_broadcastReadMore.show();
            },
            showBroadcast() {
                this.isChange = false;
                this.modalTitle = "Broadcast";
                this.obj_SelectedComponent = broadcast;
                this.isModalOpen = true;
            },
            showUpdates() {
                this.modalTitle = "Post";
                this.obj_SelectedComponent = updates;
                this.isModalOpen = true;
            },
            showPortfolio() {
                this.modalTitle = "Portfolio";
                this.obj_SelectedComponent = portfolio;
                this.isModalOpen = true;
            },
            showModal() {
                this.isModalOpen = true;
            },
            hideModal() {
                this.isModalOpen = false;
            },

            getMediumSource(file) {
                let SourceisImage = this.isImageByExt(file);
                if (SourceisImage === true) {
                    // return `data:image/jpg;base64, ${file.PostItemFileMedium}`;
                    return `data:image/jpg;base64, ${file.PostItemFile}`;
                } else {
                    return `data:application/pdf;base64, ${file.PostItemFile}`;
                }
            },

            createNew() {
                this.modalTitle = "CREATE BROADCAST";
                // this.obj_SelectedComponent = broadcast;
                this.selectedComponent = createBroadcast;
                this.isCreateModalOpen = true;
            },
            isImageByExt(obj_File) {
                let ext = String(obj_File.PostItemFileExt).toUpperCase();
                let isImage = false;

                switch (ext) {
                    case ".PNG":
                    case ".JPG":
                    case ".BMP":
                    case ".GIF":
                    case ".JPEG":
                        isImage = true;
                        break;
                    default:
                        isImage = false;
                        break;
                }

                return isImage;
            },

            // scroll load more
            getScrollPercent() {
                //Credits to Phil Ricketts @ stackoverflow
                let height = document.documentElement,
                    body = document.body,
                    scrollTop = 'scrollTop',
                    scrollHeight = 'scrollHeight';

                return (height[scrollTop] || body[scrollTop]) / ((height[scrollHeight] || body[scrollHeight]) - height.clientHeight) * 100;
            },
            isScrollable() {
                return $(document).height() > $(window).height();
            },
            debounce(func, wait, immediate) {
                // Returns a function, that, as long as it continues to be invoked, will not
                // be triggered. The function will be called after it stops being called for
                // N milliseconds. If `immediate` is passed, trigger the function on the
                // leading edge, instead of the trailing.
                let timeout, result;
                let self = this;

                let later = function (context, args) {
                    timeout = null;
                    if (args) result = func.apply(context, args);
                };

                let debounced = self.restArguments(function (args) {
                    if (timeout) clearTimeout(timeout);
                    if (immediate) {
                        let callNow = !timeout;
                        timeout = setTimeout(later, wait);
                        if (callNow) result = func.apply(this, args);
                    } else {
                        timeout = self.delay(later, wait, this, args);
                    }

                    return result;
                });

                debounced.cancel = function () {
                    clearTimeout(timeout);
                    timeout = null;
                };

                return debounced;
            },
            delay(func, wait, ...args) {
                // Lodash Delay
                /**
                 * Invokes `func` after `wait` milliseconds. Any additional arguments are
                 * provided to `func` when it's invoked.
                 *
                 * @since 0.1.0
                 * @category Function
                 * @param {Function} func The function to delay.
                 * @param {number} wait The number of milliseconds to delay invocation.
                 * @param {...*} [args] The arguments to invoke `func` with.
                 * @returns {number} Returns the timer id.
                 * @example
                 *
                 * delay(text => console.log(text), 1000, 'later')
                 * // => Logs 'later' after one second.
                 */
                if (typeof func != 'function') {
                    throw new TypeError('Expected a function');
                }
                return setTimeout(func, +wait || 0, ...args);
            },
            restArguments(func, startIndex) {
                // Some functions take a variable number of arguments, or a few expected
                // arguments at the beginning and then a variable number of values to operate
                // on. This helper accumulates all remaining arguments past the function?s
                // argument length (or an explicit `startIndex`), into an array that becomes
                // the last argument. Similar to ES6?s "rest parameter".
                startIndex = startIndex == null ? func.length - 1 : +startIndex;
                return function () {
                    let length = Math.max(arguments.length - startIndex, 0),
                        rest = Array(length),
                        index = 0;
                    for (; index < length; index++) {
                        rest[index] = arguments[index + startIndex];
                    }
                    switch (startIndex) {
                        case 0:
                            return func.call(this, rest);
                        case 1:
                            return func.call(this, arguments[0], rest);
                        case 2:
                            return func.call(this, arguments[0], arguments[1], rest);
                    }
                    let args = Array(startIndex + 1);
                    for (index = 0; index < startIndex; index++) {
                        args[index] = arguments[index];
                    }
                    args[startIndex] = rest;
                    return func.apply(this, args);
                };
            },
            // scroll load more

            displayResult(value) {
                //TODO: Show Message
                if (value == "TRUE") {
                    this.isChange = true;
                    this.hideComponentModal();
                }
            },
            hideComponentModal() {
                this.obj_SelectedComponent = false;
                this.isModalOpen = false;
                this.modalTitle = null;
            },

            isNull(obj) {
                return (obj === null || obj === undefined || obj === "undefined" || obj.length === 0 || obj === "");
            },
            async loadSingleBroadcast(NotiValue) {
                this.isParent = Cookies.get('userTypeSession');
                this.arrobj_BroadcastPost = [];

                this.array_postID = NotiValue.split(',');
                this.array_postID = JSON.stringify(this.array_postID);

                const singlePostData = await DataSource.shared.getPostByPostID(this.array_postID);

                if (singlePostData.Table) {

                    singlePostData.Table.forEach((object, index) => {
                        object.hasCover = false;

                        // if (object.PostBroadDtlMsg) {
                        //     object.PostBroadDtlMsg = this.replaceWithLink(object.PostBroadDtlMsg);
                        // }

                        let promise_GetCoverImage = DataSource.shared.getPostFileReturnFilePath(object.PostID);

                        promise_GetCoverImage.then((postResponse) => {
                            if (postResponse.Table) {
                                object.hasCover = true;

                                postResponse.Table.forEach(file => {
                                    file.numPages = undefined;

                                    if (file.PostItemFileExt.toLowerCase() === ".pdf") {
                                        let src = pdf.createLoadingTask(file.FilePath);
                                        file.pageOfSrc = src;
                                        src.promise.then(pdf => {
                                            file.numPages = pdf.numPages;
                                        });
                                    }
                                    file.oriFilePath = file.FilePath;

                                    var filename = file.PostItemID + file.PostItemFileExt;
                                    this.urltoFile(file.FilePath, filename, file.PostItemFileType).then((blobFile) => {
                                        var url = window.URL.createObjectURL(blobFile);

                                        file.FilePath = url;
                                    }).finally(() => {
                                        // this.getImagePreviews();
                                    });
                                });

                                // object.eachBroadcastDetails = postResponse.Table;
                                this.$set(object, "eachBroadcastDetails", postResponse.Table);
                            }
                        });
                    });

                    // this.arrobj_BroadcastPost.push.apply(this.arrobj_BroadcastPost, singlePostData.Table);
                }

                this.arrobj_BroadcastPost.push.apply(this.arrobj_BroadcastPost, singlePostData.Table);
                this.arrobj_singleBroadcast = this.arrobj_BroadcastPost[0];
                this.isLoading = false;
                // this.hasParams = true;
            },
            checkWithParam(NotiValue) {
                if (!this.isNull(NotiValue)) {
                    this.hasParams = true;
                    this.loadSingleBroadcast(NotiValue);
                } else {
                    this.hasParams = false;
                    this.loadBroadcast();
                }
            },
            checkNotification(notif) {
                if (this.isNull(notifGlobalVariable.NotiValue)) {
                    this.loadBroadcast();
                } else {
                    if (notifGlobalVariable.NotiType === "Broadcast") {
                        this.checkWithParam(notifGlobalVariable.NotiValue);
                    } else {
                        this.$set(notifGlobalVariable, "NotiValue", notif.NotiValue);
                        this.$set(notifGlobalVariable, "NotiType", notif.NotiType);
                    }
                }
            },

            isVideo(obj_File) {
                let ext = String(obj_File.PostItemFileExt).toUpperCase();
                let isVideo = false;

                switch (ext) {
                    case ".MP4":
                    case ".MOV":
                        isVideo = true;
                        break;
                    default:
                        isVideo = false;
                        break;
                }

                return isVideo;
            },

            isAudio(obj_File) {
                let ext = String(obj_File.PostItemFileExt).toUpperCase();
                let isAudio = false;

                switch (ext) {
                    case ".MP3":
                    case ".AAC":
                    case ".WAV":
                    case ".M4A":
                        isAudio = true;
                        break;
                    default:
                        isAudio = false;
                        break;
                }

                return isAudio;
            },

            isMobile() {
                let screenWidth = window.innerWidth;
                if (screenWidth <= 770) {
                    this.checkMobileStatus = true;
                    // return true;
                } else {
                    this.checkMobileStatus = false;
                    // return false;
                }
            },

            sleep(milliseconds) {
                return new Promise(resolve => setTimeout(resolve, milliseconds));
            },

            changeMsg(val) {
                if (val !== "") {
                    if ($('#'+val).siblings('label').text() === "Read More") {
                        $('#'+val).siblings('label').text('Hide');
                    } else {
                        $('#'+val).siblings('label').text('Read More');
                    }
                } else {
                    this.arrobj_BroadcastPost.forEach(broadItem => {
                        let lineCount = 0;

                        if (broadItem.PostBroadDtlMsg) {
                            var lines = broadItem.PostBroadDtlMsg.split("\n");
                            for (var i = 0; i < lines.length; i++) {
                                if (lines[i].length > 0) lineCount++;
                            }
                            // broadItem.totalLine = lineCount;

                            if (broadItem.PostBroadDtlMsg.length >= 60) {
                                broadItem.totalLine = 4;
                            }
                        }
                    });
                }
            },

            replaceWithLink(val) {
                const URLMatcher = /(?:(?:https?|ftp|file):\/\/|www\.|ftp\.)(?:\([-A-Z0-9+&@#\/%=~_|$?!:,.]*\)|[-A-Z0-9+&@#\/%=~_|$?!:,.])*(?:\([-A-Z0-9+&@#\/%=~_|$?!:,.]*\)|[A-Z0-9+&@#\/%=~_|$])/igm;

                const withLinks = val.replace(URLMatcher, match =>
                    `<a href="${match}" target="_blank">${match}</a>`
                );
                return withLinks;
            },

            urltoFile(url, filename, mimeType) {
                return (fetch(url)
                        .then(function (res) {
                            return res.arrayBuffer();
                        })
                        .then(function (buf) {
                            return new File([buf], filename, {type: mimeType});
                        })
                );
            },

            selectedEachBroadcast(val) {
                this.arrobj_singleBroadcast = val;
            },
        },
        mounted() {
            const self = this;

            self.isMobile();

            this.lastPostID = null;
            this.arrobj_BroadcastPost = [];
            // this.loadBroadcast();

            if (this.$route.query.postID === undefined) {
                this.hasParams = false;
                this.loadBroadcast();
            } else {
                this.singlePostID = [];
                this.singlePostID.push(this.$route.query.postID);
                this.loadSingleBroadcast(this.$route.query.postID);
                this.$router.replace({'query': null});
            }

            // this.checkNotification(notifGlobalVariable);
            //
            // this.$root.$on("notificationType", (e) => {
            //     this.checkNotification(e);
            // });

            $(document).ready(function(){
                $(".content-body-container").css("min-height", window.outerHeight);
            });

            /*#region Scroll Loader Functions*/
            $(window).scroll(self.debounce(() => {
                if (self.getScrollPercent() >= 80) {
                    if (self.arrobj_BroadcastPost.length % 10 === 0 && self.arrobj_BroadcastPost.length > 0) { // && self.hasMore
                        self.loadMoreBroadcast();
                    }
                }
            }, 250));
            /*#endregion*/
        },
        computed: {
            filteredBroadcastPost: function () {
                return this.arrobj_BroadcastPost.slice(0, 3);
            },
        },
    }
</script>

<style scoped>
    .content-body-container {
        /*display: inline-block;*/
        padding: 20px;
        margin: 0 auto;
        /*background: white;*/
        /*border-radius: 5px;*/
        /*width: 450px;*/
    }

    .broadcast-list-header-container {
        text-align: left;
        margin-bottom: 20px;
    }

    .broadcast-list-header-container > span {
        margin-right: 10px;
        display: inline-block;
        vertical-align: middle;
    }

    .broadcast-list-header-container > label{
        display: inline-block!important;
        font-weight: normal;
        font-size: 12px;
    }

    /*.btn-create-new-broadcast {*/
    /*    display: inline-block;*/
    /*    float: right;*/
    /*    padding: 5px 15px;*/
    /*    font-size: 12px;*/
    /*    min-width: 80px;*/
    /*}*/

    .btn-create-new-broadcast > i {
        margin-right: 10px;
    }

    .single-broadcast-image {
        height: 100%;
        width: auto;
        margin: 0 auto;
    }

    .btn-import-image {
        border: 1px solid #eee;
        background: white;
    }

    .image-wrapper li.postFile__item {
        padding: 20px;
    }

    .mobile-view .broadcast-list-header-container {
        text-align: center;
    }

    .btn-create-new-broadcast {
        background: #EA4C89;
        border-radius: 5px;
        color: white;
        padding: 5px 20px;
    }

    .profile {
        width: 42px;
        height: 42px;
        margin-right: 10px;
    }

    .each-broadcast {
        padding: 10px;
        background: #FFFFFF;
        border-radius: 6px;
        margin-bottom: 20px;
        width: 30%;
        display: inline-block;
        cursor: pointer;
        vertical-align: top;
        height: 350px;
        overflow: auto;
    }

    .each-broadcast:nth-child(3n+2) {
        position: relative;
        margin-left: 20px;
        margin-right: 20px;
    }

    /*.each-broadcast:nth-child(odd) {*/
    /*    position: relative;*/
    /*    margin-right: 20px;*/
    /*}*/

    /*.each-broadcast:nth-child(even) {*/
    /*    position: relative;*/
    /*    margin-left: 20px;*/
    /*}*/

    .mobile-view .each-broadcast {
        background: #FFFFFF;
        border-radius: 6px;
        width: 100%;
        display: inline-block;
        cursor: pointer;
        vertical-align: top;
        margin: 0px 0px 20px 0px;
    }

    .mobile-view .content-body-container {
        padding: 20px 0px;
        background: #E9EDF7;
    }

    .profile img {
        height: 42px;
        object-fit: contain;
    }

    .broadcast-msg input {
        opacity: 0;
        position: absolute;
        pointer-events: none;
    }

    .broadcast-msg p {
        white-space: pre-line;
        /* word-break: break-all; */
        word-break: break-word;
        display: -webkit-box;
        -webkit-line-clamp: 4;
        -webkit-box-orient: vertical;
        overflow: hidden;
    }

    .broadcast-msg input:focus ~ label {
        outline: -webkit-focus-ring-color auto 5px;
    }

    .broadcast-msg input:checked + p {
        -webkit-line-clamp: unset;
    }

    .broadcast-msg input:checked ~ label,
    .broadcast-msg p:not(.truncated) ~ label{
        /*display: none;*/
    }

    .broadcast-msg p {
        margin: 0;
    }

    .broadcast-msg label {
        /*border-radius: 4px;*/
        /*padding: 0.2em 0.6em;*/
        /*border: 1px solid #009ce2;*/
        /*background-color: #00acff;*/
        /*color: #fff;*/
        font-size: 0.8em;
    }

    .broadcast-details-container {
        background: #EDF0F4;
        min-height: calc(100vh - 20px);
        width: 30%;
        padding: 20px;
        position: sticky;
        top: 0px;
        max-height: calc(100vh - 10px);
    }


    .postFile-remainingNumber {
        position: absolute;
        display: block;
        background: #00000061;
        width: 30px;
        height: 30px;
        color: white;
        font-weight: bold;
        font-size: 12px;
        line-height: 16px;
        border: 0px;
        border-radius: 50%;
        bottom: 10px;
        right: 10px;
    }

    .each-broadcast-msg-container::-webkit-scrollbar {
        background-color: #fff;
        width: 8px;
    }

    .each-broadcast-msg-container::-webkit-scrollbar-thumb {
        background-color: #426DFF;
    }

    .each-broadcast-msg-container::-webkit-scrollbar-track {
        background-color: #ffffff;
    }

    .sans-font-style {
        font-family: sans-serif;
        font-style: normal;
        /*font-weight: normal;*/
        /*font-size: 14px;*/
        /*line-height: 16px;*/
    }

    .sans-font-style-size-12 {
        font-family: sans-serif;
        font-style: normal;
        font-weight: normal;
        font-size: 12px;
        line-height: 14px;
    }

    .sans-font-style-size-22 {
        font-family: sans-serif;
        font-style: normal;
        font-weight: bold;
        font-size: 22px;
        line-height: 28px;
    }

    .sans-font-style-size-25 {
        font-family: sans-serif;
        font-style: normal;
        font-weight: normal;
        font-size: 25px;
        line-height: 22px;
    }

    .sans-font-style-size-35 {
        font-family: sans-serif;
        font-style: normal;
        font-weight: bold;
        font-size: 35px;
        line-height: 22px;
    }
</style>